import { render, staticRenderFns } from "./RightSide.vue?vue&type=template&id=5659e1f4&scoped=true&"
import script from "./RightSide.vue?vue&type=script&lang=ts&"
export * from "./RightSide.vue?vue&type=script&lang=ts&"
import style0 from "./RightSide.vue?vue&type=style&index=0&id=5659e1f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5659e1f4",
  null
  
)

export default component.exports